import parse from 'html-react-parser';
import React from 'react';
import '../../../../client/components/editor/rich-text/html/RichTextInput.scss';
interface IProps {
  content: string | null | undefined;
}

/**
 * Permette la renderizzazione di un html sfruttando gli stili di Quill
 * @param props
 */
export function QuillHtmlRenderView(props: IProps) {
  if (!props.content) return null;

  // Di default Quill utilizza `<p><br></p>` come "documento vuoto"
  // https://github.com/quilljs/quill/issues/1235#issuecomment-273044116
  if (props.content === '<p><br></p>') {
    return null;
  }

  return (
    <div className="ql-container ql-snow ql-render">
      <div className="ql-editor ant-typography">{parse(props.content)}</div>
    </div>
  );
}
